import { BackendModule, ReadCallback } from 'i18next';
import store from '../store';
import { loadTranslations } from '../features/translations/slices/translationSlice';

import { translationBundleKey as storageKey } from '../features/language/languageConfig';

const CustomBackend: BackendModule = {
  type: 'backend',
  init: () => {
    // Initialization
  },
  read: async (language: string, namespace: string, callback: ReadCallback) => {
    try {
      // Check if translations are stored in localStorage
      const storedData = localStorage.getItem(storageKey(language));
      if (storedData) {
        console.log(`Loaded ${language} translations from localStorage`);
        callback(null, JSON.parse(storedData));
        return;
      }

      // Fetch translations from the API and store them in Redux and localStorage
      const result = await store.dispatch(loadTranslations(language));

      if (loadTranslations.fulfilled.match(result)) {
        const translations = result.payload.translations.translations;
        localStorage.setItem(
          storageKey(language),
          JSON.stringify(translations),
        );
        callback(null, translations); // Pass translations to i18next
      } else {
        callback(new Error('Failed to load translations'), false);
      }
    } catch (err) {
      console.error('Error loading translations:', err);
      callback(new Error('Error loading translations'), false);
    }
  },
};

export default CustomBackend;
